import z from "zod";

import { zAttrViewComponent } from "./attrViews/ZAttrViewComponent";

export const zAttrView = z.object({
  title: z
    .string()
    .nullish()
    .describe(
      "Если нужно чтобы в таблице заголовок отличался от zAttrMeta.title",
    ),
  width: z
    .string()
    .or(z.number())
    .nullish()
    .describe(
      "Дефолтная ширина в пикселях (number) или с использованием CSS-единиц (string)",
    ),
  minWidth: z
    .number()
    .nullish()
    .describe("Минимальная ширина колонки в пикселях"),
  component: zAttrViewComponent
    .nullish()
    .describe("Компонент для вывода атрибута в таблице"),
});
export type ZAttrView = z.infer<typeof zAttrView>;
